export default __webpack_public_path__ + "static/media/microfleece_v_skiff.0c07e629.jpg";